"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSeriesLocalizedReferenceSchema = void 0;
exports.EventSeriesLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/event-series.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "EventSeriesLocalizedReference",
    "description": "An event series groups multiple event profiles, such as a tournament or championship series. It's possible to either group event profiles directly or related event seasons (e.g. competition years).",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:event-series"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQtc2VyaWVzLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9tb2R1bGVzL3JlZmVyZW5jZS9sb2NhbGl6ZWQvY29udGVudC9ldmVudC1zZXJpZXMuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsbUNBQW1DLEdBQUc7SUFDakQsS0FBSyxFQUFFLHNGQUFzRjtJQUM3RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSwrQkFBK0I7SUFDeEMsYUFBYSxFQUFFLHVNQUF1TTtJQUN0TixNQUFNLEVBQUUsUUFBUTtJQUNoQixVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sSUFBSTtLQUNMO0lBQ0QsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFO2dCQUNOLDBCQUEwQjthQUMzQjtZQUNELE1BQU0sRUFBRSxRQUFRO1NBQ2pCO1FBQ0QsSUFBSSxFQUFFO1lBQ0osTUFBTSxFQUFFLFFBQVE7WUFDaEIsU0FBUyxFQUFFLGlHQUFpRztTQUM3RztLQUNGO0NBQ0YsQ0FBQSJ9